import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { NEWSLETTER } from "@/constants/testIds";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { site } = useSite();
  const f = site.footer;

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the collective. Check your inbox soon.");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#F4F1EA] mt-24 md:mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-[#1A1C1A]">
            {f.newsletter_title_line_1} <em className="italic">{f.newsletter_title_em}</em>{f.newsletter_title_line_3}
          </h3>
          <p className="mt-4 text-stone-600 max-w-md leading-relaxed font-light">
            {f.newsletter_body}
          </p>
          <form onSubmit={submit} className="mt-8 flex items-center gap-2 max-w-md border-b border-stone-400 pb-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              data-testid={NEWSLETTER.emailInput}
              className="flex-1 bg-transparent focus:outline-none placeholder:text-stone-500 py-2 text-sm font-sans"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid={NEWSLETTER.submitButton}
              className="text-xs uppercase tracking-[0.2em] font-medium text-[#1A1C1A] hover:opacity-60 transition-opacity"
            >
              {loading ? "Joining…" : "Join"}
            </button>
          </form>
        </div>

        <div className="md:col-span-3 md:col-start-8">
          <p className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold mb-5">Shop</p>
          <ul className="space-y-3 text-[#1A1C1A] font-light">
            <li><Link to="/shop?category=gym" className="hover:text-stone-500 transition-colors">Performance Wear</Link></li>
            <li><Link to="/shop?category=beauty" className="hover:text-stone-500 transition-colors">Renewal Beauty</Link></li>
            <li><Link to="/shop" className="hover:text-stone-500 transition-colors">All Products</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold mb-5">Brand</p>
          <ul className="space-y-3 text-[#1A1C1A] font-light">
            <li><Link to="/about" className="hover:text-stone-500 transition-colors">Our Story</Link></li>
            <li><Link to="/reviews" className="hover:text-stone-500 transition-colors">Reviews</Link></li>
            <li><Link to="/contact" className="hover:text-stone-500 transition-colors">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-stone-500 transition-colors">Admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-300/60">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-stone-500 font-sans">
          <p>© {new Date().getFullYear()} Jenova Collective — jenovacollective.co</p>
          <p className="italic font-serif text-sm text-stone-600">{f.tagline_quote}</p>
        </div>
      </div>
    </footer>
  );
}
